module.exports = __webpack_public_path__ + "img/eb74fda.png";